// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3fAor","col":"Table_col__3YdK4","fulfillmentStatus":"Table_fulfillmentStatus__1wjSt","emailCol":"Table_emailCol__2lzOH"};